<template>
  <div
    v-if="showLoadingState < 1"
    key="loading state"
    class="m-edition-section-content-subject"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="billingMyCharges"
    class="m-edition-section-content-subject"
  >
    <div class="align-items-baseline display-flex-row m-filters-and-actions">
      <form
        autocomplete="off"
        class="align-items-baseline m-form-row m-simple-filter"
        name="simple-filters-form"
        @submit.prevent="searchSimpleFilter"
      >
        <AtomSelectPrimary
          v-model.number="simpleFilter.estado"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.paymentsStates"
          keyField="id"
          name="estado"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomSelectPrimary
          v-model.number="simpleFilter.periodo"
          :disabled="pagination.showLoadingState"
          :elements="$filters.parameters.periods"
          keyField="id"
          name="periodo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="searchSimpleFilter"
        />

        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @reloadListing="reloadListing"
        />
      </form>

      <div class="m-dropdown-primary">
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.filter"
          :disabled="pagination.showLoadingState"
          @switchDropDown="$dropDown.switchDropDown"
        />
        <MoleculeEditionBillingMyPaymentsDropDownFilters
          :filter-seted="filter"
          @reloadListing="reloadListing"
          @searchAdvancedFilter="searchAdvancedFilter"
        />
      </div>
    </div>

    <div class="m-table-primary">
      <table
        v-show="pagos.length"
        class="table-layout-fixed"
      >
        <tr>
          <th
            class="text-align-center"
            width="13%"
          >
            {{ $t('mEditionBillingMyPayments.table.thDate') }}
          </th>
          <th
            class="text-align-left"
            width="18%"
          >
            {{ $t('mEditionBillingMyPayments.table.thDetail') }}
          </th>
          <th
            class="text-align-center"
            width="14%"
          >
            {{ $t('mEditionBillingMyPayments.table.thMethod') }}
          </th>
          <th
            class="text-align-center"
            width="9%"
          >
            {{ $t('mEditionBillingMyPayments.table.thType') }}
          </th>
          <th
            class="text-align-center"
            width="12%"
          >
            {{ $t('mEditionBillingMyPayments.table.thToPay') }}
          </th>
          <th
            class="text-align-center"
            width="11%"
          >
            {{ $t('mEditionBillingMyPayments.table.thDiscount') }}
          </th>
          <th
            class="text-align-right"
            width="15%"
          >
            {{ $t('mEditionBillingMyPayments.table.thTotal') }}
          </th>
          <th
            class="text-align-center"
            width="8%"
          >
            {{ $t('mEditionBillingMyPayments.table.thInvoice') }}
          </th>
        </tr>
        <tr
          v-for="(pago, index) in pagos"
          :key="index"
          class="row-data"
        >
          <td class="text-align-center text-transform-capitalize text-white-space-nowrap">
            {{ $moment(pago.fecha_pago).utc().format('D MMM YYYY') }}
          </td>
          <td class="break-word text-align-left">
            {{ pago.concepto_pago }}
          </td>
          <td class="text-align-center">
            {{ pago.medio_pago }}
          </td>
          <td class="text-align-center">
            {{ pago.tipo_comprobante }}
          </td>
          <td class="text-align-center">
            {{ getPagoFrequency(pago.pago_cuotas, pago.pago_frecuencia, pago.pago_intervalo) }}
          </td>
          <td class="text-align-center">
            <span v-if="pago.detalle && pago.detalle.cuponCodigo" >
              {{ pago.detalle.cuponCodigo }}
            </span>
            <span v-else >
              -
            </span>
          </td>
          <td class="text-align-right text-white-space-nowrap">
            <span>{{ pago.divisa }} {{ pago.monto.toFixed(2) }}</span>
            <span class="text-color-black-35"> {{ pago.divisa_iso_code }}</span><br>
            <small :class="[$filters.getPaymentStateValue(pago.pago_estado, 'class'), 'font-weight-regular']">
              {{ paymentsStates.find(paymentState => paymentState.id === pago.pago_estado).name }}
            </small>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.record"
              :element="pago"
              @goToInvoice="goToInvoice"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMyPayments',

  components: {
    MoleculeEditionBillingMyPaymentsDropDownFilters: () => import('@/components/molecules/MoleculeEditionBillingMyPaymentsDropDownFilters'),
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  data () {
    return {
      buttonIconRounded: {
        record: {
          class: 'a-button-no-border a-button-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'far fa-file-alt',
          method: 'goToInvoice',
          tooltip: 'Ver',
          type: 'button'
        }
      },

      buttonSecondary: {
        filter: {
          class: 'a-button-secondary a-button-side',
          component: 'MoleculeEditionBillingMyPaymentsDropDownFilters',
          icon: 'fas fa-filter',
          method: 'switchDropDown',
          text: this.$t('mEditionBillingMyPayments.buttonSecondary.filterText'),
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'reloadListing',
          text: '',
          tooltip: this.$t('mEditionBillingMyPayments.tooltips.restart'),
          type: 'button'
        }
      },

      filter: {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        cupon: '',
        pagina: 1,
        limite: 10
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 0,
        totalQuantity: 0
      },

      pagos: [],

      paymentsStates: [
        {
          class: '',
          id: '',
          name: 'Todos los estados'
        },

        {
          class: 'text-color-warning',
          id: 4,
          name: 'Anulado'
        },

        {
          class: 'text-color-info',
          id: 1,
          name: 'Confirmado'
        },

        {
          class: 'text-color-success',
          id: 2,
          name: 'Pagado'
        },

        {
          class: 'text-color-danger',
          id: 0,
          name: 'Pendiente'
        },

        {
          class: 'text-color-info',
          id: 3,
          name: 'Reembolsado'
        }
      ],

      showLoadingState: 0,

      simpleFilter: {
        estado: '',
        periodo: 0
      }
    }
  },

  computed: {
    academyDataColor () {
      return this.$store.getters.getAcademyData.color
    }
  },

  created () {
    if (this.academyDataColor) {
      this.buttonIconRounded.record.class = `${this.buttonIconRounded.record.class} a-button-academy-secondary`
      this.buttonSecondary.filter.class = `${this.buttonSecondary.filter.class} a-button-academy-secondary`
      this.buttonSecondary.reset.class = `${this.buttonSecondary.filter.class} a-button-academy-secondary`
    } else {
      this.buttonIconRounded.record.class = `${this.buttonIconRounded.record.class} a-button-billing-secondary`
      this.buttonSecondary.filter.class = `${this.buttonSecondary.filter.class} a-button-billing-secondary`
      this.buttonSecondary.reset.class = `${this.buttonSecondary.filter.class} a-button-billing-secondary`
    }

    this.readVentasPagosAlumno()
  },

  methods: {
    getPagoFrequency (cuotas, frecuencia, intervalo) {
      return cuotas > 1
        ? `${cuotas} pagos mensuales`
        : frecuencia === 0
          ? 'Contado'
          : `1 pago cada ${intervalo} ${this.$filters.getFrequencyValue(frecuencia, 'name')}`
    },

    goToInvoice (pago) {
      this.$router.push(`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${pago.id_pago}/${this.$t('mEditionMenu.billing.myPayments.children.invoice.subedition')}`)
    },

    readVentasPagosAlumno () {
      if (!this.pagination.showLoadingState) {
        this.pagination.showLoadingState = true
        this.$services.read('ventas', 'readVentasPagosAlumno', {}, [this.$store.getters.getAcademyData.id], this.filter)
          .then(response => {
            console.log(response)
            this.pagos = response.data.pagos
            this.pagination.currentQuantity = this.pagos.length
            this.pagination.totalPages = response.data.pages
            this.pagination.totalQuantity = response.data.total
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
          .catch(error => {
            console.log(error)
            this.pagos = []
            this.pagination.currentQuantity = 0
            this.pagination.totalPages = 0
            this.pagination.totalQuantity = 0
            this.pagination.showLoadingState = false
            this.showLoadingState++
          })
      }
    },

    reloadListing () {
      this.resetSimpleFilter()
      this.resetAdvancedFilter()
      this.setPaginationCurrentPage(1)
    },

    resetAdvancedFilter () {
      this.filter = {
        estado: [],
        divisa: [],
        pasarela_pago: [],
        fecha_desde: '',
        fecha_hasta: '',
        cupon: '',
        pagina: 1,
        limite: 10
      }
    },

    resetSimpleFilter () {
      this.simpleFilter = {
        estado: '',
        periodo: 0
      }
    },

    searchAdvancedFilter (advancedFilter) {
      this.resetSimpleFilter()
      this.filter = Object.assign({}, advancedFilter)
      this.setPaginationCurrentPage(1)
    },

    searchSimpleFilter () {
      this.resetAdvancedFilter()

      if (this.simpleFilter.estado !== '') {
        this.filter.estado[0] = this.simpleFilter.estado
      }

      if (this.simpleFilter.periodo === '') {
        this.simpleFilter.periodo = 0
      }

      this.filter.fecha_desde = this.$filters.parameters.periods[this.simpleFilter.periodo].dateFrom
      this.filter.fecha_hasta = this.$filters.parameters.periods[this.simpleFilter.periodo].dateTo
      this.setPaginationCurrentPage(1)
    },

    setPaginationCurrentPage (page) {
      this.filter.pagina = page
      this.pagination.currentPage = page
      this.readVentasPagosAlumno()
    }
  }
}
</script>
